import React, { useState } from "react";

// Components
import { Button, Form } from 'react-bulma-components';
import { Thumbnail, CompanyDetail } from "shared/components/user";
import { Edit3  } from 'react-feather';

//actions + utils
import { useAuthUser } from 'shared/state';
import { ROLES } from "shared/enums";

// Styles
import styles from './AddUser.module.scss';

const AddUser = ({ onAddNewUser, onClose }) => {
    const { Checkbox, Input, Field, Control, Label, Select } = Form;
    const [newContact, setNewContact] = useState({ status: 1 });
    const { user } = useAuthUser();

    const replaceNullUndefined = (obj) => {
        return obj === null || obj === undefined ? '' : obj;
    }

    const handleInputChange = (e) => {
        setNewContact(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }

    const handleNewContact = (e) => {
        e.preventDefault();

        const newContactObj = {
            ...newContact,
            parent_id: 1
        }

        onAddNewUser(newContactObj);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setNewContact({});
        onClose();
    }

    const handleOverlayClick = (e) => {
        e.preventDefault();
        onClose();
    }

    return (
        <div className={ styles.wrapper }>
            <div className={ styles.detail }>
                <form onSubmit={ handleNewContact }>
                    <article className={ styles.inner }>
                        <header className={ styles.header }>
                            <div className={ styles.innerHeader }>
                                <h2>New User</h2>
                                <div className={ styles.settings }>
                                    <Field className="mr-6">
                                        <Label>Role</Label>
                                        <Control>
                                            <Select
                                                required
                                                name="role"
                                                onChange={ handleInputChange }
                                                value={ replaceNullUndefined(newContact.role) }>
                                                <option value="">
                                                    - Choose an option -
                                                </option>
                                                { Object.entries(ROLES).map(([role, label], i) => {
                                                    return (
                                                        <option key={i} value={ role }>
                                                            { label }
                                                        </option> )
                                                    })
                                                }
                                            </Select>
                                        </Control>
                                    </Field>
                                    <Field>
                                        <Label>Status</Label>
                                        <Control>
                                            <Select
                                                required
                                                name="status"
                                                className={ replaceNullUndefined(newContact.status) === '0' ? styles.inactive : styles.active }
                                                onChange={ handleInputChange }
                                                value={ replaceNullUndefined(newContact.status)}>
                                                <option value="1">
                                                    Active
                                                </option>
                                                <option value="0">
                                                    Inactive
                                                </option>
                                            </Select>
                                        </Control>
                                    </Field>
                                </div>
                            </div>
                            <div className={ styles.image }>
                                <Thumbnail
                                    size="large"
                                    image={ replaceNullUndefined(newContact.image) }
                                    backgroundColor="grey" />
                                <div className={ styles.edit }>
                                    <Edit3 size={18} />
                                </div>
                            </div>
                        </header>
                        <div className={ styles.user }>
                            <Field>
                                <Label>Name</Label>
                                <Control>
                                    <Input
                                        name="name"
                                        onChange={ handleInputChange }
                                        required
                                        value={ replaceNullUndefined(newContact.name) }
                                    />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Last Name</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="surname"
                                        required
                                        value={ replaceNullUndefined(newContact.surname) }
                                    />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Email</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="email"
                                        required
                                        value={ replaceNullUndefined(newContact.email) }
                                        />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Phone Number</Label>
                                <Control>
                                    <Input
                                        onChange={ handleInputChange }
                                        name="phone"
                                        type="tel"
                                        value={ replaceNullUndefined(newContact.phone) }
                                        />
                                </Control>
                            </Field>

                            <Field>
                                <Label>City</Label>
                                <Control>
                                    <Input
                                        name="city"
                                        onChange={ handleInputChange }
                                        type="text"
                                        value={ replaceNullUndefined(newContact.city) }
                                        />
                                </Control>
                            </Field>
                            <Field>
                                <Label>Zip code</Label>
                                <Control>
                                    <Input
                                        name="zip"
                                        onChange={ handleInputChange }
                                        type="text"
                                        value={ replaceNullUndefined(newContact.zip) }
                                        />
                                </Control>
                            </Field>

                            <Field>
                                <Label>Country</Label>
                                <Control>
                                    <Input
                                        name="country"
                                        onChange={ handleInputChange }
                                        type="text"
                                        value={ replaceNullUndefined(newContact.zip) }
                                        />
                                </Control>
                            </Field>
                        </div>
                        <footer className={ styles.actions }>
                            <Button onClick={ handleCancel }>
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                className={ styles.secondary }>
                                Save Changes
                            </Button>
                        </footer>
                    </article>
                </form>
            </div>
        </div>
    )
}

export default AddUser;
